// Brand bar shown at the top of every page (logged in or out). Hamburger
// lives on the left, bell (and any other right-edge action) on the right,
// and the SaaS logo sits in the middle. The logo is the home button when
// onHome is provided — duplicating it as a separate icon was redundant
// and crowded the bar off-screen on narrow phones.
//
// The header always shows the TechnicianLogs brand — the tenant's own
// logo lives next to the signed-in user's name on the homepage (App.js),
// and on PDF exports. Keeping the header SaaS-branded gives a consistent
// platform identity across pages and orgs.
export default function BrandHeader({
  left = null,
  right = null,
  onHome = null,
  isOnHome = false,
}) {
  const logo = (
    <img
      src="/logo.jpg"
      alt="TechnicianLogs"
      style={{
        height: "44px",
        maxWidth: "100%",
        objectFit: "contain",
        display: "block",
      }}
    />
  );
  return (
    <div
      style={{
        width: "100%",
        background: "white",
        borderBottom: "1px solid #e5e7eb",
        display: "flex",
        alignItems: "center",
        padding: "8px 12px",
        marginBottom: "12px",
        boxSizing: "border-box",
        gap: "8px",
      }}
    >
      <div
        style={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {left}
      </div>
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {onHome ? (
          <button
            type="button"
            onClick={onHome}
            disabled={isOnHome}
            title="Home"
            aria-label="Home"
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: isOnHome ? "default" : "pointer",
            }}
          >
            {logo}
          </button>
        ) : (
          logo
        )}
      </div>
      <div
        style={{
          flexShrink: 0,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {right}
      </div>
    </div>
  );
}
